module.exports = __webpack_public_path__ + "img/Folded_Paper_Werk_WUR_image_1.ccbf6c46.png";